<template>
  <owal-modal-panel
    :title="`Remove ${this.name}?`"
    :bottom-buttons="buttons"
    @button-click="handleButton"
  >
    Are you sure you'd like to remove {{ this.name }}?
    Their face will no longer be tagged or appear in searches, but their photos may be preserved as training data.
  </owal-modal-panel>
</template>

<script>
// import OwalForm from '@/libraries/owal-ui/forms/OwalForm'
import OwalModalPanel from '@/libraries/owal-ui/panels/OwalModalPanel'
import { SVC_C } from '@/libraries/api/base'
import { mapActions } from 'vuex'

export default {
  name: 'OwalAddFace',
  components: { OwalModalPanel },
  props: {
    name: {
      type: String,
      required: true,
    },
    faceId: {
      type: String,
      required: true,
    },
  },
  computed: {
    buttons () {
      return [{
        title: 'Yes',
        identifier: 'confirm',
      },
      {
        title: 'No',
        identifier: 'close',
      }]
    },
  },
  methods: {
    ...mapActions(['loadFrontendFaces']),
    handleButton: function (identifier) {
      if (identifier === 'close') {
        this.closeWindow(false) // Cancel button
      } else if (identifier === 'confirm') {
        this.removeFace()
      }
    },
    closeWindow (didDelete) {
      const payload = {
        success: didDelete,
        action: 'delete',
        uuid: this.faceId,
      }
      this.$emit('close', payload)
    },
    removeFace () {
      const path = `/api/v6/faces/${this.faceId}`
      // console.log(`Requesting delete for path ${path}`)
      const self = this

      SVC_C.delete(path).then(function (response) {
        // console.log(`Response: ${JSON.stringify(response, null, 2)}`)
        self.loadFrontendFaces()
        self.closeWindow(true)
      }).catch(function (error) {
        console.error(error)
        // console.log(`Error deleting: ${error}.`)
        // console.log(`Response: ${JSON.stringify(response, null, 2)}`)
        self.closeWindow(false)
      })
    },
  },
}
</script>

<style scoped>

</style>
